import script from "./RedesignAboutModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignAboutModal.vue?vue&type=script&setup=true&lang=js"

import "./RedesignAboutModal.vue?vue&type=style&index=0&id=886d714e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-886d714e"]])

export default __exports__